import { uiStore } from "@/store/store-accessor";
import * as n from "@/types/notifications";

const NotificationLogger = {
  log: {
    notification: (notification: n.BreakdanceNotification): void => {
      logNotification(notification);
    },
    message: (message: string) => {
      logNotification({
        type: "MESSAGE",
        message: message
      });
    },
    errorMessage: (message: string) => {
      logNotification({
        type: "ERROR",
        message: message
      });
    }
  },
  dismiss: (index: number) => {
    const notifications = [...uiStore.notifications];
    notifications.splice(index, 1);
    uiStore.setNotifications(notifications);
  },
  dismissAll: () => {
    uiStore.setNotifications([]);
  }
};

export type NotificationLogger = typeof NotificationLogger;

window.Breakdance = {
  ...window.Breakdance,
  NotificationLogger
};

export default NotificationLogger;

function logNotification(notification: n.BreakdanceNotification) {
  const notifications = [...uiStore.notifications, notification];

  uiStore.setNotifications(notifications);
}
